<template>
  <v-list
    v-bind="$attrs"
    :nav="nav"
  >
    <slot></slot>
  </v-list>
</template>

<script>
export default {
  name: "AppList",
  props: {
    nav: {
      type: Boolean,
      required: false,
    },
  },
};
</script>
